export class RoomAcuityRecord {
    id: number;
    shiftRecordId: number;
    roomId: number;
    acuityCategoryId: number;
    isVacant: boolean;
}